(() => {
  'use strict';
  const compact = window.matchMedia('(max-width: 749px)');
  const init = (scope = document) => {
    scope.querySelectorAll('[data-sf-filter-disclosure]').forEach((disclosure) => {
      if (disclosure.dataset.sfReady) return;
      disclosure.dataset.sfReady = 'true';
      disclosure.open = !compact.matches;
      disclosure.querySelector('[data-sf-filter-done]')?.addEventListener('click', () => {
        disclosure.open = false;
        disclosure.querySelector('summary')?.focus();
      });
    });
  };
  compact.addEventListener('change', () => document.querySelectorAll('[data-sf-filter-disclosure]').forEach((disclosure) => { disclosure.open = !compact.matches; }));
  globalThis.AvidStorefrontUI = { init };
  // Selecting a specialist search mode must expose its active inputs.
  document.addEventListener('click', (event) => {
    const mode = event.target.closest('[data-shock-mode]');
    if (mode) { const disclosure = mode.closest('[data-shock-finder]')?.querySelector('[data-sf-filter-disclosure]'); if (disclosure) disclosure.open = true; }
  });
  document.addEventListener('keydown', (event) => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const mode = event.target.closest('[data-shock-mode]');
    if (mode) { const disclosure = mode.closest('[data-shock-finder]')?.querySelector('[data-sf-filter-disclosure]'); if (disclosure) disclosure.open = true; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
